// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import { API_BASE_URL } from "../Api/apiconnector";

// export default function ReportEditorModule({
//   dicomId,
//   currentUser,
//   closeEditor,
//   editorData,
//   setEditorData,
//   patientData,
// }) {
//   const [services, setServices] = useState([]);
//   const [ckTemplates, setCkTemplates] = useState([]);
//   const [rsnaTemplates, setRsnaTemplates] = useState([]);
//   const [selectedCKTemplate, setSelectedCKTemplate] = useState(null);
//   const [selectedRSNATemplate, setSelectedRSNATemplate] = useState(null);
//   const [showTemplateInput, setShowTemplateInput] = useState(false);
//   const [newTemplateName, setNewTemplateName] = useState("");
//   const [saveStatus, setSaveStatus] = useState("");
  
//   const [showRSNATemplateInput, setShowRSNATemplateInput] = useState(false);
//   const [newRSNATemplateName, setNewRSNATemplateName] = useState("");
//   // Add these states at top
// const [searchCK, setSearchCK] = useState("");
// const [searchRSNA, setSearchRSNA] = useState("");


//   // 🧩 Fetch user-specific templates
//   useEffect(() => {
//     if (!currentUser?.id) return;

//     // ✅ Fetch only current user's CKEditor templates
//     axios
//       .get(`${API_BASE_URL}/ckeditor_templates/?user_id=${currentUser.id}`)
//       .then((res) => setCkTemplates(res.data.templates))
//       .catch((err) =>
//         console.error("❌ Error loading CKEditor templates:", err)
//       );

//     // ✅ Fetch only current user's RSNA templates
//     axios
//       .get(`${API_BASE_URL}/rsna/templates/?user_id=${currentUser.id}`)
//       .then((res) => setRsnaTemplates(res.data.templates))
//       .catch((err) =>
//         console.error("❌ Error loading RSNA templates:", err)
//       );
//   }, [currentUser]);

//   // 🧩 Format Date-Time
//   const getFormattedDateTime = () => {
//     const now = new Date();
//     const pad = (n) => n.toString().padStart(2, "0");
//     return {
//       date: `${pad(now.getDate())}-${pad(now.getMonth() + 1)}-${now.getFullYear()}`,
//       time: `${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`,
//     };
//   };

//   // 🧩 Build Header
//   const buildDemographyHeader = useCallback(() => {
//     const { date, time } = getFormattedDateTime();
//     return `
//       <div class="report-header" style="font-family: Arial, sans-serif;">
//         <div style="display:flex; justify-content:space-between; align-items:center;">
//           <img class="doctor-logo" src="${currentUser?.logo || ""}" alt="Doctor Logo" style="height:70px; width:auto;" />
//         </div>
//         <table class="patient-demography" border="1" cellspacing="0" cellpadding="5" style="width:100%; font-size:14px; margin-top:10px;">
//           <tr>
//             <td><b>Patient Name:</b> ${patientData?.patient_name || ""}</td>
//             <td><b>Patient ID:</b> ${patientData?.patient_id || ""}</td>
//           </tr>
//           <tr>
//             <td><b>Patient Age:</b> ${patientData?.age || ""}</td>
//             <td><b>Patient Gender:</b> ${patientData?.gender || ""}</td>
//           </tr>
//           <tr>
//             <td><b>Test Date:</b> ${patientData?.study_date || ""}</td>
//             <td><b>Report Date:</b> ${date}</td>
//           </tr>
//           <tr>
//             <td><b>Referral Dr:</b> ${patientData?.referring_doctor_name || ""}</td>
//             <td><b>Report Time:</b> ${time}</td>
//           </tr>
//         </table>
//       </div>
//     `;
//   }, [currentUser, patientData]);

//   // 🧩 Build Footer
//   const buildDoctorFooter = useCallback(() => {
//     return `
//       <div class="report-footer" style="margin-top:30px; font-family:Arial; font-size:14px;">
//         <img class="doctor-signature" src="${currentUser?.signature || ""}" alt="Doctor Signature" style="height:50px;" /><br/>
//         <b class="doctor-name">${currentUser?.full_name || ""}</b><br/>
//         <span class="doctor-designation">${currentUser?.designation || ""}</span><br/>
//         <span class="doctor-reg">Reg. No. ${currentUser?.registration_no || ""}</span>
//       </div>
//     `;
//   }, [currentUser]);

//   // 🧩 Load existing report or create new
//   useEffect(() => {
//     if (!patientData?.study_id) return;

//     axios
//       .get(`${API_BASE_URL}/get_editor_content/${patientData.study_id}/`)
//       .then((res) => {
//         if (res.data.editor_content) {
//           setEditorData(res.data.editor_content);
//         } else {
//           const newReport = `
//   ${buildDemographyHeader()}
//   <div 
//     class="report-body" 
//     style="
//       margin-top:20px; 
//       border:1px solid #ccc; 
//       border-radius:6px; 
//       padding:10px; 
//       min-height:250px;
//     " 
//     contenteditable="true"
//   >
//     <p><br/></p>
//   </div>
//   ${buildDoctorFooter()}
// `;

//         }
//       })
//       .catch((err) => console.error("❌ Error fetching report:", err));
//   }, [patientData?.study_id]);

//   const handleTemplateInsert = (content) => {
//     if (!editorData) {
//       const base = `
//         ${buildDemographyHeader()}
//         <div class="report-body" style="margin-top:20px;">${content}</div>
//         ${buildDoctorFooter()}
//       `;
//       setEditorData(base);
//       return;
//     }

//     const parser = new DOMParser();
//     const doc = parser.parseFromString(editorData, "text/html");
//     const bodyDiv = doc.querySelector(".report-body");

//     if (bodyDiv) {
//       bodyDiv.innerHTML = content;
//       setEditorData(doc.body.innerHTML);
//     } else {
//       const merged = `
//         ${buildDemographyHeader()}
//         <div class="report-body" style="margin-top:20px;">${content}</div>
//         ${buildDoctorFooter()}
//       `;
//       setEditorData(merged);
//     }
//   };

//   // ✅ Fetch single CKEditor template (user specific)
//   const handleCKTemplateSelect = async (templateId) => {
//     setSelectedCKTemplate(templateId);
//     const res = await axios.get(
//       `${API_BASE_URL}/ckeditor_templates/${templateId}/?user_id=${currentUser.id}`
//     );
//     handleTemplateInsert(res.data.template_content);
//   };

//   // ✅ Fetch single RSNA template (user specific)
//   const handleRSNATemplateSelect = async (templateId) => {
//     setSelectedRSNATemplate(templateId);
//     const res = await axios.get(
//       `${API_BASE_URL}/rsna/templates/${templateId}/?user_id=${currentUser.id}`
//     );
//     handleTemplateInsert(res.data.template_content);
//   };

//   // 🧩 Extract body content only
//   const extractMainContent = (html) => {
//     if (!html) return "";
//     const parser = new DOMParser();
//     const doc = parser.parseFromString(html, "text/html");
//     [
//       ".report-header",
//       ".patient-demography",
//       ".report-footer",
//       ".doctor-logo",
//       ".doctor-signature",
//       ".doctor-name",
//       ".doctor-designation",
//       ".doctor-reg",
//     ].forEach((cls) => {
//       doc.querySelectorAll(cls).forEach((el) => el.remove());
//     });
//     const bodyDiv = doc.querySelector(".report-body");
//     return bodyDiv ? bodyDiv.innerHTML.trim() : doc.body.innerHTML.trim();
//   };

//  // ✅ Save only selected content as CKEditor Template
// const handleSaveTemplate = async () => {
//   if (!currentUser || !currentUser.id) {
//     alert("Current user not loaded yet.");
//     return;
//   }

//   if (!newTemplateName.trim()) {
//     alert("Please enter a template name before saving.");
//     return;
//   }

//   // ✅ Try to get selected HTML content from the editor
//   const selection = window.getSelection();
//   const selectedContent = selection?.rangeCount
//     ? selection.getRangeAt(0).cloneContents()
//     : null;

//   let selectedHTML = "";
//   if (selectedContent) {
//     const tempDiv = document.createElement("div");
//     tempDiv.appendChild(selectedContent);
//     selectedHTML = tempDiv.innerHTML.trim();
//   }

//   if (!selectedHTML) {
//     alert("Please select some content in the editor to save as a template!");
//     return;
//   }

//   try {
//     const response = await axios.post(`${API_BASE_URL}/ckeditor_templates/`, {
//       name: newTemplateName.trim(),
//       content: selectedHTML, // ✅ Save only selected content
//       user_id: currentUser.id,
//     });

//     alert("✅ Template saved successfully!");
//     setNewTemplateName("");
//     setShowTemplateInput(false);

//     // Refresh template list
//     const res = await axios.get(
//       `${API_BASE_URL}/ckeditor_templates/?user_id=${currentUser.id}`
//     );
//     setCkTemplates(res.data.templates);
//   } catch (error) {
//     console.error("❌ Error while saving template:", error);
//     alert("Failed to save template. Check console for details.");
//   }
// };

//   const handleSaveRSNATemplate = async () => {
//     if (!newRSNATemplateName.trim()) {
//       alert("Please enter RSNA Template Name!");
//       return;
//     }

//     const cleanContent = extractMainContent(editorData);
//     if (!cleanContent) return alert("Editor content is empty!");

//     try {
//       await axios.post(`${API_BASE_URL}/rsna/templates/`, {
//         name: newRSNATemplateName,
//         content: cleanContent,
//         user_id: currentUser.id,
//       });

//       alert("✅ RSNA Template saved successfully!");
//       setNewRSNATemplateName("");
//       setShowRSNATemplateInput(false);

//       // Refresh template list
//       const res = await axios.get(`${API_BASE_URL}/rsna/templates/?user_id=${currentUser.id}`);
//       setRsnaTemplates(res.data.templates);
//     } catch (err) {
//       console.error("❌ Error saving RSNA template:", err);
//       alert("Failed to save RSNA Template.");
//     }
//   };

//   // 🧩 Auto-save report
//   const saveReportToBackend = useCallback(async () => {
//     if (!patientData?.study_id || !editorData) return;
//     try {
//       setSaveStatus("Saving...");
//       const payload = {
//         study_id: patientData.study_id,
//         patient_id: patientData.patient_id,
//         editor_content: editorData,
//       };
//       const res = await axios.post(`${API_BASE_URL}/save_editor_content/`, payload, {
//         headers: { "Content-Type": "application/json" },
//       });
//       if (res.status === 200) {
//         setSaveStatus("✅ Saved");
//       }
//     } catch (error) {
//       console.error("❌ Auto-save error:", error);
//       setSaveStatus("❌ Save failed");
//     }
//   }, [editorData, patientData]);

//   useEffect(() => {
//     if (!editorData) return;
//     const delay = setTimeout(() => saveReportToBackend(), 500);
//     return () => clearTimeout(delay);
//   }, [editorData, saveReportToBackend]);

//   return (
//   <div className="report-editor-module">

//     {/* NAVBAR STYLE TOOLBAR */}
//     <div
//       className="editor-controls"
//       style={{
//         marginBottom: "10px",
//         display: "flex",
//         alignItems: "center",
//         gap: "10px",
//         flexWrap: "wrap",
//         padding: "6px 10px",
//         background: "#f5f5f5",
//         borderRadius: "6px",
//         border: "1px solid #ddd",
//       }}
//     >

//       {/* CK SEARCH + DROPDOWN */}
//       <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
//         <input
//           type="text"
//           placeholder="Search CK"
//           value={searchCK}
//           onChange={(e) => setSearchCK(e.target.value)}
//           style={{
//             height: "28px",
//             padding: "4px 8px",
//             width: "150px",
//             fontSize: "12px",
//             borderRadius: "4px",
//             border: "1px solid #ccc",
//           }}
//         />

//         <select
//           onChange={(e) => handleCKTemplateSelect(e.target.value)}
//           value={selectedCKTemplate || ""}
//           style={{
//             height: "28px",
//             width: "150px",
//             fontSize: "12px",
//             whiteSpace: "nowrap",
//             overflow: "hidden",
//             textOverflow: "ellipsis",
//             padding: "4px",
//             borderRadius: "4px",
//           }}
//         >
//           <option value="">CK Template</option>
//           {ckTemplates
//             .filter((t) =>
//               t.name.toLowerCase().includes(searchCK.toLowerCase())
//             )
//             .map((t) => (
//               <option key={t.id} value={t.id} title={t.name}>
//                 {t.name}
//               </option>
//           ))}
//         </select>
//       </div>

//       {/* RSNA SEARCH + DROPDOWN */}
//       <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
//         <input
//           type="text"
//           placeholder="Search RSNA"
//           value={searchRSNA}
//           onChange={(e) => setSearchRSNA(e.target.value)}
//           style={{
//             height: "28px",
//             padding: "4px 8px",
//             width: "150px",
//             fontSize: "12px",
//             borderRadius: "4px",
//             border: "1px solid #ccc",
//           }}
//         />

//         <select
//           onChange={(e) => handleRSNATemplateSelect(e.target.value)}
//           value={selectedRSNATemplate || ""}
//           style={{
//             height: "28px",
//             width: "150px",
//             fontSize: "12px",
//             whiteSpace: "nowrap",
//             overflow: "hidden",
//             textOverflow: "ellipsis",
//             padding: "4px",
//             borderRadius: "4px",
//           }}
//         >
//           <option value="">RSNA Template</option>
//           {rsnaTemplates
//             .filter((t) =>
//               t.name.toLowerCase().includes(searchRSNA.toLowerCase())
//             )
//             .map((t) => (
//               <option key={t.id} value={t.id} title={t.name}>
//                 {t.name}
//               </option>
//           ))}
//         </select>
//       </div>

//       {/* SMALL BUTTONS */}
//       <button
//         onClick={() => setShowTemplateInput(!showTemplateInput)}
//         style={{
//           height: "28px",
//           padding: "4px 10px",
//           fontSize: "12px",
//           background: "#007bff",
//           color: "white",
//           border: "none",
//           borderRadius: "4px",
//           cursor: "pointer",
//         }}
//       >
//         Save CK
//       </button>

//       <button
//         onClick={() => setShowRSNATemplateInput(!showRSNATemplateInput)}
//         style={{
//           height: "28px",
//           padding: "4px 10px",
//           fontSize: "12px",
//           background: "#28a745",
//           color: "white",
//           border: "none",
//           borderRadius: "4px",
//           cursor: "pointer",
//         }}
//       >
//         Save RSNA
//       </button>
//     </div>

//     {/* CK Input Box */}
//     {showTemplateInput && (
//       <div style={{ marginTop: "5px" }}>
//         <input
//           type="text"
//           placeholder="Template Name"
//           value={newTemplateName}
//           onChange={(e) => setNewTemplateName(e.target.value)}
//           style={{
//             padding: "6px 10px",
//             borderRadius: "6px",
//             border: "1px solid #ccc",
//             marginRight: "10px",
//           }}
//         />
//         <button
//           onClick={handleSaveTemplate}
//           style={{
//             background: "#007bff",
//             color: "white",
//             border: "none",
//             padding: "6px 12px",
//             borderRadius: "6px",
//             cursor: "pointer",
//           }}
//         >
//           Save
//         </button>
//       </div>
//     )}

//     {/* RSNA Input Box */}
//     {showRSNATemplateInput && (
//       <div style={{ marginTop: "5px" }}>
//         <input
//           type="text"
//           placeholder="RSNA Template Name"
//           value={newRSNATemplateName}
//           onChange={(e) => setNewRSNATemplateName(e.target.value)}
//           style={{
//             padding: "6px 10px",
//             borderRadius: "6px",
//             border: "1px solid #ccc",
//             marginRight: "10px",
//           }}
//         />
//         <button
//           onClick={handleSaveRSNATemplate}
//           style={{
//             background: "#28a745",
//             color: "white",
//             border: "none",
//             padding: "6px 12px",
//             borderRadius: "6px",
//             cursor: "pointer",
//           }}
//         >
//           Save
//         </button>
//       </div>
//     )}

//     {/* Status */}
//     <div style={{ fontSize: "13px", marginTop: "5px", color: "#444" }}>
//       {saveStatus && <span>{saveStatus}</span>}
//     </div>
//   </div>
// );
// }

import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { API_BASE_URL } from "../Api/apiconnector";

export default function ReportEditorModule({
  dicomId,
  currentUser,
  closeEditor,
  editorData,
  setEditorData,
  patientData,
  onDraftLoaded,
  onDraftFetchComplete,
}) {
  const [services, setServices] = useState([]);
  const [ckTemplates, setCkTemplates] = useState([]);
  const [rsnaTemplates, setRsnaTemplates] = useState([]);
  const [selectedCKTemplate, setSelectedCKTemplate] = useState(null);
  const [selectedRSNATemplate, setSelectedRSNATemplate] = useState(null);
  const [showTemplateInput, setShowTemplateInput] = useState(false);
  const [newTemplateName, setNewTemplateName] = useState("");
  const [saveStatus, setSaveStatus] = useState("");
  
  const [showRSNATemplateInput, setShowRSNATemplateInput] = useState(false);
  const [newRSNATemplateName, setNewRSNATemplateName] = useState("");
  // Add these states at top
const [searchCK, setSearchCK] = useState("");
const [searchRSNA, setSearchRSNA] = useState("");


  // 🧩 Fetch user-specific templates
  useEffect(() => {
    if (!currentUser?.id) return;

    // ✅ Fetch only current user's CKEditor templates
    axios
      .get(`${API_BASE_URL}/ckeditor_templates/?user_id=${currentUser.id}`)
      .then((res) => setCkTemplates(res.data.templates))
      .catch((err) =>
        console.error("❌ Error loading CKEditor templates:", err)
      );

    // ✅ Fetch only current user's RSNA templates
    axios
      .get(`${API_BASE_URL}/rsna/templates/?user_id=${currentUser.id}`)
      .then((res) => setRsnaTemplates(res.data.templates))
      .catch((err) =>
        console.error("❌ Error loading RSNA templates:", err)
      );
  }, [currentUser]);

  // 🧩 Format Date-Time
  const getFormattedDateTime = () => {
    const now = new Date();
    const pad = (n) => n.toString().padStart(2, "0");
    return {
      date: `${pad(now.getDate())}-${pad(now.getMonth() + 1)}-${now.getFullYear()}`,
      time: `${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`,
    };
  };

// 🧩 Build Header
const buildDemographyHeader = useCallback(() => {
  const { date, time } = getFormattedDateTime();
  return `
    <div class="report-header" style="font-family: Arial, sans-serif;">
      
      <table class="patient-demography" border="1" cellspacing="0" cellpadding="5"
        style="width:100%; font-size:14px; margin-top:10px;">
        
        <tr>
          <td><b>Name:</b> ${patientData?.patient_name || ""}</td>
          <td><b>Patient ID:</b> ${patientData?.patient_id || ""}</td>
          <td><b> Age:</b> ${patientData?.age || ""}</td>
        </tr>
        <tr>
          <td><b> Gender:</b> ${patientData?.gender || ""}</td>
          <td><b>Test Date:</b> ${patientData?.study_date || ""}</td>
          <td><b>Report Date:</b> ${date}</td>
        </tr>

        <tr>
          <td><b>Referral Dr:</b> ${patientData?.referring_doctor_name || ""}</td>
          <td><b>Report Time:</b> ${time}</td>
        </tr>

      </table>
    </div>
  `;
}, [patientData]);


  // 🧩 Build Footer
  const buildDoctorFooter = useCallback(() => {
    return `
      <div class="report-footer" style="margin-top:30px; font-family:Arial; font-size:14px;">
        <img class="doctor-signature" src="${currentUser?.signature || ""}" alt="Doctor Signature" style="height:50px;" /><br/>
        <b class="doctor-name">${currentUser?.full_name || ""}</b><br/>
        <span class="doctor-designation">${currentUser?.designation || ""}</span><br/>
      </div>
    `;
  }, [currentUser]);

  // 🧩 Load existing report or create new
  useEffect(() => {
    if (!patientData?.study_id) return;

    axios
      .get(`${API_BASE_URL}/get_editor_content/${patientData.study_id}/`)
      .then((res) => {
        const hasDraft = !!res.data.editor_content;
        // Notify viewer that draft fetch finished (exists OR not)
        if (typeof onDraftFetchComplete === "function") {
          onDraftFetchComplete(hasDraft);
        }
        // If draft exists → load it
        if (hasDraft) {
          if (window.editor) {
            window.editor.setData(res.data.editor_content);
            console.log("📌 Loaded saved draft into CKEditor");
          }

          setEditorData(res.data.editor_content);

          if (typeof onDraftLoaded === "function") {
            onDraftLoaded();
          }
        }
         else {
          const newReport = `
  ${buildDemographyHeader()}
  <div 
    class="report-body" 
    style="
      margin-top:20px; 
      border:1px solid #ccc; 
      border-radius:6px; 
      padding:10px; 
      min-height:250px;
    " 
    contenteditable="true"
  >
    <p><br/></p>
  </div>
  ${buildDoctorFooter()}
`;
        }
      })
      .catch((err) => {
        // In error, still notify viewer that no draft exists
        if (typeof onDraftFetchComplete === "function") {
          onDraftFetchComplete(false);
        }
        console.error("❌ Error fetching report:", err)});
  }, [patientData?.study_id]);

  const handleTemplateInsert = (content) => {
    if (!editorData) {
      const base = `
        ${buildDemographyHeader()}
        <div class="report-body" style="margin-top:20px;">${content}</div>
        ${buildDoctorFooter()}
      `;
      setEditorData(base);
      return;
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(editorData, "text/html");
    const bodyDiv = doc.querySelector(".report-body");

    if (bodyDiv) {
      bodyDiv.innerHTML = content;
      setEditorData(doc.body.innerHTML);
    } else {
      const merged = `
        ${buildDemographyHeader()}
        <div class="report-body" style="margin-top:20px;">${content}</div>
        ${buildDoctorFooter()}
      `;
      setEditorData(merged);
    }
  };

  // ✅ Fetch single CKEditor template (user specific)
  const handleCKTemplateSelect = async (templateId) => {
    setSelectedCKTemplate(templateId);
    const res = await axios.get(
      `${API_BASE_URL}/ckeditor_templates/${templateId}/?user_id=${currentUser.id}`
    );
    handleTemplateInsert(res.data.template_content);
  };

  // ✅ Fetch single RSNA template (user specific)
  const handleRSNATemplateSelect = async (templateId) => {
    setSelectedRSNATemplate(templateId);
    const res = await axios.get(
      `${API_BASE_URL}/rsna/templates/${templateId}/?user_id=${currentUser.id}`
    );
    handleTemplateInsert(res.data.template_content);
  };

  // 🧩 Extract body content only
  const extractMainContent = (html) => {
    if (!html) return "";
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    [
      ".report-header",
      ".patient-demography",
      ".report-footer",
      ".doctor-logo",
      ".doctor-signature",
      ".doctor-name",
      ".doctor-designation",
      ".doctor-reg",
    ].forEach((cls) => {
      doc.querySelectorAll(cls).forEach((el) => el.remove());
    });
    const bodyDiv = doc.querySelector(".report-body");
    return bodyDiv ? bodyDiv.innerHTML.trim() : doc.body.innerHTML.trim();
  };

 // ✅ Save only selected content as CKEditor Template
const handleSaveTemplate = async () => {
  if (!currentUser || !currentUser.id) {
    alert("Current user not loaded yet.");
    return;
  }

  if (!newTemplateName.trim()) {
    alert("Please enter a template name before saving.");
    return;
  }

  // ✅ Try to get selected HTML content from the editor
  const selection = window.getSelection();
  const selectedContent = selection?.rangeCount
    ? selection.getRangeAt(0).cloneContents()
    : null;

  let selectedHTML = "";
  if (selectedContent) {
    const tempDiv = document.createElement("div");
    tempDiv.appendChild(selectedContent);
    selectedHTML = tempDiv.innerHTML.trim();
  }

  if (!selectedHTML) {
    alert("Please select some content in the editor to save as a template!");
    return;
  }

  try {
    const response = await axios.post(`${API_BASE_URL}/ckeditor_templates/`, {
      name: newTemplateName.trim(),
      content: selectedHTML, // ✅ Save only selected content
      user_id: currentUser.id,
    });

    alert("✅ Template saved successfully!");
    setNewTemplateName("");
    setShowTemplateInput(false);

    // Refresh template list
    const res = await axios.get(
      `${API_BASE_URL}/ckeditor_templates/?user_id=${currentUser.id}`
    );
    setCkTemplates(res.data.templates);
  } catch (error) {
    console.error("❌ Error while saving template:", error);
    alert("Failed to save template. Check console for details.");
  }
};

  const handleSaveRSNATemplate = async () => {
    if (!newRSNATemplateName.trim()) {
      alert("Please enter RSNA Template Name!");
      return;
    }

    const cleanContent = extractMainContent(editorData);
    if (!cleanContent) return alert("Editor content is empty!");

    try {
      await axios.post(`${API_BASE_URL}/rsna/templates/`, {
        name: newRSNATemplateName,
        content: cleanContent,
        user_id: currentUser.id,
      });

      alert("✅ RSNA Template saved successfully!");
      setNewRSNATemplateName("");
      setShowRSNATemplateInput(false);

      // Refresh template list
      const res = await axios.get(`${API_BASE_URL}/rsna/templates/?user_id=${currentUser.id}`);
      setRsnaTemplates(res.data.templates);
    } catch (err) {
      console.error("❌ Error saving RSNA template:", err);
      alert("Failed to save RSNA Template.");
    }
  };

  // 🧩 Auto-save report
  const saveReportToBackend = useCallback(async () => {
    if (!patientData?.study_id || !editorData) return;
    try {
      setSaveStatus("Saving...");
      const payload = {
        study_id: patientData.study_id,
        patient_id: patientData.patient_id,
        editor_content: editorData,
      };
      const res = await axios.post(`${API_BASE_URL}/save_editor_content/`, payload, {
        headers: { "Content-Type": "application/json" },
      });
      if (res.status === 200) {
        setSaveStatus("✅ Saved");
      }
    } catch (error) {
      console.error("❌ Auto-save error:", error);
      setSaveStatus("❌ Save failed");
    }
  }, [editorData, patientData]);

  useEffect(() => {
    if (!editorData) return;
    const delay = setTimeout(() => saveReportToBackend(), 500);
    return () => clearTimeout(delay);
  }, [editorData, saveReportToBackend]);

  return (
  <div className="report-editor-module">

    {/* NAVBAR STYLE TOOLBAR */}
    <div
      className="editor-controls"
      style={{
        marginBottom: "10px",
        display: "flex",
        alignItems: "center",
        gap: "10px",
        flexWrap: "wrap",
        padding: "6px 10px",
        background: "#f5f5f5",
        borderRadius: "6px",
        border: "1px solid #ddd",
      }}
    >

      {/* CK SEARCH + DROPDOWN */}
      <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
        <input
          type="text"
          placeholder="Search CK"
          value={searchCK}
          onChange={(e) => setSearchCK(e.target.value)}
          style={{
            height: "28px",
            padding: "4px 8px",
            width: "150px",
            fontSize: "12px",
            borderRadius: "4px",
            border: "1px solid #ccc",
          }}
        />

        <select
          onChange={(e) => handleCKTemplateSelect(e.target.value)}
          value={selectedCKTemplate || ""}
          style={{
            height: "28px",
            width: "150px",
            fontSize: "12px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            padding: "4px",
            borderRadius: "4px",
          }}
        >
          <option value="">CK Template</option>
          {ckTemplates
            .filter((t) =>
              t.name.toLowerCase().includes(searchCK.toLowerCase())
            )
            .map((t) => (
              <option key={t.id} value={t.id} title={t.name}>
                {t.name}
              </option>
          ))}
        </select>
      </div>

      {/* RSNA SEARCH + DROPDOWN */}
      <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
        <input
          type="text"
          placeholder="Search RSNA"
          value={searchRSNA}
          onChange={(e) => setSearchRSNA(e.target.value)}
          style={{
            height: "28px",
            padding: "4px 8px",
            width: "150px",
            fontSize: "12px",
            borderRadius: "4px",
            border: "1px solid #ccc",
          }}
        />

        <select
          onChange={(e) => handleRSNATemplateSelect(e.target.value)}
          value={selectedRSNATemplate || ""}
          style={{
            height: "28px",
            width: "150px",
            fontSize: "12px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            padding: "4px",
            borderRadius: "4px",
          }}
        >
          <option value="">RSNA Template</option>
          {rsnaTemplates
            .filter((t) =>
              t.name.toLowerCase().includes(searchRSNA.toLowerCase())
            )
            .map((t) => (
              <option key={t.id} value={t.id} title={t.name}>
                {t.name}
              </option>
          ))}
        </select>
      </div>

      {/* SMALL BUTTONS */}
      <button
        onClick={() => setShowTemplateInput(!showTemplateInput)}
        style={{
          height: "28px",
          padding: "4px 10px",
          fontSize: "12px",
          background: "#007bff",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
        }}
      >
        Save CK
      </button>

      <button
        onClick={() => setShowRSNATemplateInput(!showRSNATemplateInput)}
        style={{
          height: "28px",
          padding: "4px 10px",
          fontSize: "12px",
          background: "#28a745",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
        }}
      >
        Save RSNA
      </button>
    </div>

    {/* CK Input Box */}
    {showTemplateInput && (
      <div style={{ marginTop: "5px" }}>
        <input
          type="text"
          placeholder="Template Name"
          value={newTemplateName}
          onChange={(e) => setNewTemplateName(e.target.value)}
          style={{
            padding: "6px 10px",
            borderRadius: "6px",
            border: "1px solid #ccc",
            marginRight: "10px",
          }}
        />
        <button
          onClick={handleSaveTemplate}
          style={{
            background: "#007bff",
            color: "white",
            border: "none",
            padding: "6px 12px",
            borderRadius: "6px",
            cursor: "pointer",
          }}
        >
          Save
        </button>
      </div>
    )}

    {/* RSNA Input Box */}
    {showRSNATemplateInput && (
      <div style={{ marginTop: "5px" }}>
        <input
          type="text"
          placeholder="RSNA Template Name"
          value={newRSNATemplateName}
          onChange={(e) => setNewRSNATemplateName(e.target.value)}
          style={{
            padding: "6px 10px",
            borderRadius: "6px",
            border: "1px solid #ccc",
            marginRight: "10px",
          }}
        />
        <button
          onClick={handleSaveRSNATemplate}
          style={{
            background: "#28a745",
            color: "white",
            border: "none",
            padding: "6px 12px",
            borderRadius: "6px",
            cursor: "pointer",
          }}
        >
          Save
        </button>
      </div>
    )}

    {/* Status */}
    <div style={{ fontSize: "13px", marginTop: "5px", color: "#444" }}>
      {saveStatus && <span>{saveStatus}</span>}
    </div>
  </div>
);
}